// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3O-co","options":"AnswerScale_options__1mCGI","selected":"AnswerScale_selected__Q5YIx"};